import { v4 as uuidv4 } from 'uuid'
export const zoneTypes = [...new Array(5)].map((_: any, index: number) => ({
  id: uuidv4(),
  name: 'Zone Type ' + ++index,
  __typename: 'ZoneType'
}))
